import { api, queryKeys, type Ticket } from '@alpha/api-client';
import { useQuery } from '@tanstack/react-query';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { useTableQuery } from '../../hooks/useTableQuery';
import { formatDateTime, statusTone } from '../../lib/format';
import { Chip } from '../../ui';
import { SUPPORT_TABS } from './CreateTicket';

const col = createColumnHelper<Ticket>();

export function TicketList() {
  const { query, setPage } = useTableQuery();

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.tickets(query),
    queryFn: () => api.support.list(query),
  });

  const columns = useMemo(
    () => [
      col.accessor('id', {
        header: 'Ticket',
        cell: (i) => <Link to={`/support/view/${i.getValue()}`}>#{i.getValue()}</Link>,
      }),
      col.accessor('subject', { header: 'Subject' }),
      col.accessor('category', { header: 'Category', cell: (i) => i.getValue() ?? '—' }),
      col.accessor('status', {
        header: 'Status',
        cell: (i) => <Chip tone={statusTone(i.getValue())}>{i.getValue()}</Chip>,
      }),
      col.accessor('updated_at', { header: 'Updated', cell: (i) => formatDateTime(i.getValue()) }),
    ],
    [],
  );

  return (
    <>
      <PageHeader title="My Tickets" tabs={SUPPORT_TABS} />
      <DataTable<Ticket>
        title="Tickets"
        columns={columns}
        data={data?.data}
        meta={data?.meta}
        isLoading={isLoading}
        error={error as Error | null}
        emptyLabel="You have not raised any tickets"
        onPageChange={setPage}
      />
    </>
  );
}
